import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { LOCATION } = STEP_IDENTIFIER_NAME;

export const location: StepConfig = {
	name: LOCATION,
	isAuthenticationRequired: false,
	isEnabled: () => true,
};
